var _circle, _rect, _circle2, _rect2, _path, _circle3, _circle4, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAura(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1176,
    height: 446,
    viewBox: "0 0 1176 446",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 33,
    r: 32.5,
    fill: "#0266FF",
    stroke: "#0266FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 122.5,
    y: 50.5,
    width: 19,
    height: 58,
    fill: "#0266FF",
    stroke: "#0266FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 354,
    cy: 33,
    r: 32.5,
    fill: "#0266FF",
    stroke: "#0266FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 344.5,
    y: 50.5,
    width: 19,
    height: 58,
    fill: "#0266FF",
    stroke: "#0266FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141 115H345C416.797 115 475 173.203 475 245V260.75C475 323.849 423.849 375 360.75 375V385.988L360.538 375.002L208.057 377.939C203.511 378.027 199.135 379.66 195.647 382.563L195.312 382.849L152.156 420.404C151.894 420.632 151.738 420.658 151.66 420.668C151.53 420.684 151.322 420.667 151.086 420.56C150.849 420.452 150.7 420.306 150.627 420.197C150.583 420.132 150.5 419.997 150.5 419.649V388C150.5 380.82 144.68 375 137.5 375C67.636 375 11 318.364 11 248.5V245C11 173.203 69.203 115 141 115Z",
    stroke: "#0266FF",
    strokeWidth: 22
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.5,
    cy: 248.5,
    r: 45,
    fill: "#0266FF",
    stroke: "#0266FF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 337.5,
    cy: 248.5,
    r: 45,
    fill: "#0266FF",
    stroke: "#0266FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M718.824 313H683.792L665.464 268.688H603.984L585.656 313H550.624L622.08 141.32H646.904L718.824 313ZM654.096 238.76L634.608 186.096H634.144L614.656 238.76H654.096ZM856.454 250.36C856.454 267.683 853.129 281.216 846.478 290.96C840.756 299.003 833.254 305.267 823.974 309.752C814.849 314.237 805.26 316.48 795.206 316.48C785.308 316.48 775.718 314.315 766.438 309.984C757.313 305.653 749.889 299.621 744.166 291.888C737.052 282.453 733.494 268.611 733.494 250.36V141.32H765.278V250.36C765.278 274.643 775.177 286.784 794.974 286.784C814.772 286.784 824.67 274.643 824.67 250.36V141.32H856.454V250.36ZM1000.21 313H961.701L916.229 247.344H915.765V313H883.981V141.32H936.645C954.895 141.32 968.815 145.187 978.405 152.92C991.861 163.747 998.589 177.589 998.589 194.448C998.589 201.872 997.119 209.373 994.181 216.952C991.242 224.376 987.221 230.563 982.117 235.512C975.157 242.008 965.645 246.725 953.581 249.664L1000.21 313ZM966.805 197C966.805 188.648 963.866 182.229 957.989 177.744C952.111 173.259 944.842 171.016 936.181 171.016H915.765V223.448H936.181C945.151 223.448 952.498 221.205 958.221 216.72C963.943 212.235 966.805 205.661 966.805 197ZM1173.53 313H1138.5L1120.17 268.688H1058.69L1040.37 313H1005.33L1076.79 141.32H1101.61L1173.53 313ZM1108.81 238.76L1089.32 186.096H1088.85L1069.37 238.76H1108.81Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAura);
export default __webpack_public_path__ + "static/media/aura.96cacbcd5164ee37dfa6bdcde6efae70.svg";
export { ForwardRef as ReactComponent };